import React, { useState, useEffect, FC } from 'react';
import { Box, Dialog, DialogActions, DialogContent, IconButton } from '@mui/material';
import { NotificacaoElemento } from '../Notifications';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useSwipeable } from "react-swipeable";
import ContentNotification from '../Notifications/ContentNotification';
import { NotificacoesCarrossel } from '../Notifications/DialogCarrosselNotification';
import { Close } from '@mui/icons-material';

const Carrossel: FC<NotificacoesCarrossel> = ({ handleCloseDialog, notificacoes, openDialogCarrossel, onVisualizar}) => {
    const theme = useTheme();
    const [notificacaoAtual, setNotificacaoAtual] = React.useState(0);
    const [maxSteps, setMaxSteps] = useState<number>(0);
    const [marcadosVisualizado, setMarcadosVisualizado] = useState<number[]>([]);
    const total = notificacoes?.length;

    useEffect(() => {
        setMaxSteps(notificacoes.length);
        setMarcadosVisualizado([]);
    }, [notificacoes]);

    useEffect(() => {
        if (notificacaoAtual === notificacoes.length - 1) return;

        const timer = setTimeout(() => {
            setNotificacaoAtual((prev) => prev + 1);
        }, 15000);

        return () => clearTimeout(timer);
    }, [notificacaoAtual, notificacoes.length]);

    const handleNext = () => {
        setNotificacaoAtual((prevNotificacao) => prevNotificacao + 1);
    };

    const handleBack = () => {
        setNotificacaoAtual((prevNotificacao) => prevNotificacao - 1);
    };

    useEffect(() => {
        const current = notificacoes?.[notificacaoAtual];
        if (current && !marcadosVisualizado?.includes(current.id )) {
            const _vusuzalidados = [...marcadosVisualizado]
            // disparar atualização da visualização
            onVisualizar(current.id)
            // marcar como visualiado
            _vusuzalidados.push(current.id)
            setMarcadosVisualizado(_vusuzalidados);
        } 
    }, [notificacaoAtual])

    const handlers = useSwipeable({
        onSwipedLeft: () =>
            setNotificacaoAtual((prev) => (prev + 1) % total),

        onSwipedRight: () =>
            setNotificacaoAtual((prev) => (prev - 1 + total) % total),

        trackMouse: true,
    });

    return (
        <Dialog
            open={openDialogCarrossel}
            onClose={handleCloseDialog}
            maxWidth="lg"
            className='popups-carrossel'
        >
            <DialogContent style={{ padding: 0 }}>
                <Box className='dialog-carrossel'>
                    <Paper
                        elevation={0}
                    >
                        <Box className="close-carrosel">
                            <IconButton onClick={() =>{  handleCloseDialog(); }} size="large"><Close /></IconButton>
                        </Box>
                        <div
                            {...handlers}
                            style={{ overflow: "hidden", width: "100%" }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    transition: "transform 0.4s ease",
                                    transform: `translateX(-${notificacaoAtual * 100}%)`,
                                    direction: theme.direction === "rtl" ? "rtl" : "ltr",
                                }}
                            >
                                {notificacoes.map((step: NotificacaoElemento, index: number) => (
                                    <div
                                        key={`notificacao-content-${index}`}
                                        style={{ 
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            flexShrink: 0,
                                            overflow: "hidden",
                                        }}
                                    >
                                        <ContentNotification
                                            className="content-notification"
                                            elementoAtributos={step.elementoAtributos}
                                            handleCloseDialog={handleCloseDialog}
                                            onClose={() => {}}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Paper>
                </Box>
            </DialogContent>
            <DialogActions style={{ padding: 0 }}>
                <Box className="mobile-stepper">
                    <MobileStepper
                        steps={maxSteps}
                        position="static"
                        variant='dots'
                        activeStep={notificacaoAtual}
                        nextButton={
                            <Button
                                size="small"
                                onClick={handleNext}
                                disabled={notificacaoAtual === maxSteps - 1}
                            >
                                {theme.direction === 'rtl' ? (
                                    <KeyboardArrowLeft />
                                ) : (
                                    <KeyboardArrowRight />
                                )}
                            </Button>
                        }
                        backButton={
                            <Button size="small" onClick={handleBack} disabled={notificacaoAtual === 0}>
                                {theme.direction === 'rtl' ? (
                                    <KeyboardArrowRight />
                                ) : (
                                    <KeyboardArrowLeft />
                                )}
                            </Button>
                        }
                    />
                </Box>
            </DialogActions>
        </Dialog>
    );
}
export default Carrossel;
